
// export const BASE_URL = 'http://localhost:3004/api/';
export const BASE_URL = `${window.location.origin}/api/`;


const getToken = () => {
  return localStorage.getItem("token");
};

// GET
export async function getApi(path) {
  const token = getToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
  if (!res.ok) {
    let data;
    try {
      data = await res.json();
    } catch {
      data = await res.text();
    }
    return { error: true, status: res.status, data };
  }
  return { error: false, data: await res.json() };
}

// POST
export async function postApi(path, body) {
  const token = getToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let data;
    try {
      data = await res.json();
    } catch {
      data = await res.text();
    }
    return { error: true, status: res.status, data };
  }
  return { error: false, data: await res.json() };
}

// PATCH
export async function patchApi(path, body) {
  const token = getToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let data;
    try {
      data = await res.json();
    } catch {
      data = await res.text();
    }
    return { error: true, status: res.status, data };
  }
  return { error: false, data: await res.json() };
}

// PUT
export async function putApi(path, body) {
  const token = getToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    let data;
    try {
      data = await res.json();
    } catch {
      data = await res.text();
    }
    return { error: true, status: res.status, data };
  }
  return { error: false, data: await res.json() };
}

// DELETE
export async function deleteApi(path) {
  const token = getToken();
  const res = await fetch(`${BASE_URL}${path}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    },
  });
  if (!res.ok) {
    let data;
    try {
      data = await res.json();
    } catch {
      data = await res.text();
    }
    return { error: true, status: res.status, data };
  }
  return { error: false, data: await res.json() };
}

// File Upload
export async function uploadFile(path, file, fields = {}) {
  const token = getToken();
  const url = `${BASE_URL}${path}`;
  const formData = new FormData();

  formData.append("pdf", file); // ← CHANGE THIS LINE: 'file' → 'pdf'

  Object.entries(fields).forEach(([key, value]) => {
    formData.append(key, value);
  });

  const res = await fetch(url, {
    method: "POST",
    headers: {
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    body: formData,
  });

  if (!res.ok) {
    let data;
    try {
      data = await res.json();
    } catch {
      data = await res.text();
    }
    return { error: true, status: res.status, data };
  }
  return { error: false, data: await res.json() };
}
